module.exports = __webpack_public_path__ + "media/career/01-benefit-stay-home-25fb15f5.svg";